var module = angular.module('meternet.config.controllers', []);

module.controller('configCtrl', function ($scope, $state) {

});
